module.exports = __webpack_public_path__ + "img/consulta-pediatrica.6c829812.jpg";